export default [
  {
    path: '/saude-bucal',
    component: () => import('@/pages/IndicadoresAps/SaudeBucal/Index.vue'),
  },
  {
    path: '/primeira-consulta-programada',
    component: () =>
      import(
        '@/pages/IndicadoresAps/SaudeBucal/PrimeiraConsultaProgramada/components/Template.vue'
      ),
    children: [
      {
        path: '/primeira-consulta-programada',
        component: () =>
          import(
            '@/pages/IndicadoresAps/SaudeBucal/PrimeiraConsultaProgramada/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/tratamentos-concluidos',
    component: () =>
      import(
        '@/pages/IndicadoresAps/SaudeBucal/TratamentosConcluidos/components/Template.vue'
      ),
    children: [
      {
        path: '/tratamentos-concluidos',
        component: () =>
          import(
            '@/pages/IndicadoresAps/SaudeBucal/TratamentosConcluidos/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/exodontias',
    component: () =>
      import(
        '@/pages/IndicadoresAps/SaudeBucal/Exodontias/components/Template.vue'
      ),
    children: [
      {
        path: '/exodontias',
        component: () =>
          import('@/pages/IndicadoresAps/SaudeBucal/Exodontias/Index.vue'),
      },
    ],
  },
  {
    path: '/escovacao-supervisionada',
    component: () =>
      import(
        '@/pages/IndicadoresAps/SaudeBucal/EscovacaoSupervisionada/components/Template.vue'
      ),
    children: [
      {
        path: '/escovacao-supervisionada',
        component: () =>
          import(
            '@/pages/IndicadoresAps/SaudeBucal/EscovacaoSupervisionada/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/procedimentos-odonto-preventivos',
    component: () =>
      import(
        '@/pages/IndicadoresAps/SaudeBucal/ProcedimentosOdontoPreventivos/components/Template.vue'
      ),
    children: [
      {
        path: '/procedimentos-odonto-preventivos',
        component: () =>
          import(
            '@/pages/IndicadoresAps/SaudeBucal/ProcedimentosOdontoPreventivos/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/tratamentos-restauradores-atramautico',
    component: () =>
      import(
        '@/pages/IndicadoresAps/SaudeBucal/TratamentoRestauradorAtraumatico/components/Template.vue'
      ),
    children: [
      {
        path: '/tratamentos-restauradores-atramautico',
        component: () =>
          import(
            '@/pages/IndicadoresAps/SaudeBucal/TratamentoRestauradorAtraumatico/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/saude-bucal-gestantes',
    component: () =>
      import(
        '@/pages/IndicadoresAps/SaudeBucal/Gestantes/components/Template.vue'
      ),
    children: [
      {
        path: '/saude-bucal-gestantes',
        component: () =>
          import('@/pages/IndicadoresAps/SaudeBucal/Gestantes/Index.vue'),
      },
    ],
  },
]
